import { Icons, HexIcon, Typography, Stack } from '@cast/design-system';

export const OptimizingForPerformanceState = () => (
  <Stack
    direction="row"
    gap={12}
    alignItems="flex-start"
    data-testid="savings-summary-no-savings"
  >
    <HexIcon
      icon={<Icons.Gauge />}
      iconColor="grey.600"
      hexColor="green.300"
      size={48}
    />
    <Stack gap={4}>
      <Typography variant="A1">Optimizing for performance</Typography>
      <Typography variant="P12R" color="textSecondary">
        Resource requests match our recommendations. We&apos;re ensuring
        workloads have exactly the resources they need for optimal performance.
      </Typography>
    </Stack>
  </Stack>
);
